import { Injectable, Injector, OnInit } from "@angular/core";
import { uniqueId } from "lodash";

@Injectable()
export class LoadTimeService {
  startLoadTime: any;
  constructor() {}

  beginTimeMeasure() {
    const requestId = uniqueId();
    (<any>window).workingRequests.push({
      id: requestId,
      start: new Date(),
      end: null,
      points: []
    });
    return requestId;
  }

  findRequest(reqId) {
    let requestInfo = null;
    (<any>window).workingRequests.forEach(item => {
      if (item.id === reqId) {
        requestInfo = item;
      }
    });
    return requestInfo;
  }

  addPoint(reqId) {
    let requestInfo = this.findRequest(reqId);
    if (requestInfo) {
      const c = new Date().getTime();
      const time = c - requestInfo.start.getTime();
      requestInfo.points.push(time);
    }
  }

  endTimeMeasure(reqId) {
    let requestInfo = this.findRequest(reqId);
    if (requestInfo && requestInfo.start) {
      requestInfo.end = new Date();
    }
  }

  calculateTimeMeasure(
    reqId
  ): { bucket: string; loadTime: number; points: number[] } {
    let requestInfo = this.findRequest(reqId);
    if (requestInfo && requestInfo.start && requestInfo.end) {
      const loadTime = requestInfo.end - requestInfo.start;
      let bucket;

      switch (true) {
        case loadTime < 0: {
          bucket = "ERROR";
          break;
        }
        case loadTime < 1000: {
          bucket = "LoadTime_0-1secs";
          break;
        }
        case loadTime < 2000: {
          bucket = "LoadTime_1-2secs";
          break;
        }
        case loadTime < 3000: {
          bucket = "LoadTime_2-3secs";
          break;
        }
        case loadTime < 4000: {
          bucket = "LoadTime_3-4secs";
          break;
        }
        case loadTime < 5000: {
          bucket = "LoadTime_4-5secs";
          break;
        }
        case loadTime < 10000: {
          bucket = "LoadTime_5-10secs";
          break;
        }
        default: {
          bucket = "LoadTime_10+secs ";
          break;
        }
      }

      this.startLoadTime = null;
      return { bucket: bucket, loadTime: loadTime, points: requestInfo.points };
    }
    return { bucket: "ERROR", loadTime: 0, points: requestInfo.points };
  }
}
